import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { HttpVerb } from "shared/utils/enums";
import ContextType from "shared/enums/ContextType";
import InventoryType from "shared/enums/InventoryType";
import ApiPurchaseOrder from "shared/model/ApiPurchaseOrder";
import ContextEntityType from "shared/enums/ContextEntityType";
import ApiPurchaseOrderRequest from "shared/types/ApiPurchaseOrderRequest";
import { ApiRateCardForRegForm } from "shared/types/ApiRateCardForRegForm";
import { useGetApiData, usePostApiData } from "shared/datalayer";
import ApiAdditionalBulkTicketPurchase from "shared/types/ApiAdditionalBulkTicketPurchase";

export function useGetBulkTicketRate({
  registrationParticipantId,
  ticketFormId
}: {
  registrationParticipantId?: string;
  ticketFormId: string;
}) {
  return useGetApiData<ApiRateCardForRegForm>(
    MyExpApi.FETCH_BULK_TICKET_RATE,
    { params: { registrationParticipantId, ticketFormId } },
    { enabled: Boolean(registrationParticipantId) }
  );
}

export function useInitBulkTicketPurchase({ successHandler }: { successHandler: (data: ApiPurchaseOrder) => void }) {
  return usePostApiData<ApiPurchaseOrder, ApiAdditionalBulkTicketPurchase>(MyExpApi.INIT_BULK_TICKET_PURCHASE, {
    onSuccess: (data: ApiPurchaseOrder) => successHandler(data)
  });
}

export function useGetBulkTicketPurchaseHistoryList(
  registrationParticipantId?: string,
  successHandler?: (data: Array<ApiPurchaseOrder>) => void
) {
  const paramsReqObj: ApiPurchaseOrderRequest = {
    contextEntityType: ContextEntityType.PARTICIPANT,
    inventoryTypeFilter: [InventoryType.BULK_TICKET],
    contextType: ContextType.REGISTRATION,
    entityId: registrationParticipantId as string,
    registrationParticipantId: registrationParticipantId
  };
  return useGetApiData<Array<ApiPurchaseOrder>>(
    MyExpApi.GET_BULK_TICKET_PURCHASE_ORDER_LIST,
    { method: HttpVerb.POST, body: paramsReqObj },
    {
      enabled: Boolean(registrationParticipantId),
      onSuccess: data => successHandler?.(data)
    }
  );
}
